import { combineReducers } from '@reduxjs/toolkit';
import createRoleReducer from './create/createSlice';
import roleListReducer from './list/listSlice';
import deleteRoleReducer from './delete/deleteSlice';

const rolesSlice = combineReducers({
    create: createRoleReducer,
    list: roleListReducer,
    delete: deleteRoleReducer,
});

export default rolesSlice;
